module.exports = __webpack_public_path__ + "static/media/trash-alt-solid.ce8e2a41.svg";